import styled from 'styled-components';

export const RoomFlavorsContainer = styled.div(
  props => `
 width: ${props.isMultiRoom && props.isNoInclusions ? '67%' : '75%'};
  flex: ${props.isMultiRoom && props.isNoInclusions ? '' : props.flexGrowShrink}
`,
);

export const StylingFillerContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const StylingFillerColumn = styled.div(
  props => `
  flex: 1;
  // width:30rem;
  border-right: 1px solid ${props.theme.colors.downriver.light};
  &:last-child{
    border-right:none;
  }
`,
);
